import React, { useState } from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { mdiCommentAlertOutline } from '@mdi/js';

import { Button, Toggler, Icons, WideAlert, Radio } from '@components';
import {
  RegimeTributarioAssistidoSchema,
  RegimeTributarioAssistidoValues,
} from '@schemas';
import { enviaFormRequest } from '@store/user/actions';

export const OpcaoRegimeTributacaoAssistido = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={RegimeTributarioAssistidoValues}
          validationSchema={RegimeTributarioAssistidoSchema}
          onSubmit={(values) => {
            setLoading(true);
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <WideAlert className="mb-4" iconClear={false}>
                <div className="d-block d-lg-flex align-items-center">
                  <Icons
                    path={mdiCommentAlertOutline}
                    color="var(--primary-color)"
                    size={4}
                    style={{ marginRight: 4 }}
                  />
                  <p className="ts-14">
                    <strong>Aviso importante:</strong> Somente poderão optar
                    pela alteração do Regime Progressivo para o Regime
                    Regressivo de Tributação os assistidos e pensionistas que:
                    <ol className="fw-bold">
                      <li>
                        Estão vinculados a planos de previdência complementar
                        estruturados na modalidade Contribuição Variável (Plano
                        B) ou Contribuição Definida (Plano Taesaprev);
                      </li>
                      <li>Tiveram seu benefício concedido até 10/01/2024.</li>
                    </ol>
                    <p>
                      A alternativa escolhida neste Termo de Opção determinará,
                      de forma <strong>irrevogável e irretratável</strong>, o
                      Regime de Tributação aplicável ao seu Imposto de Renda.
                      Caso tenha dúvidas ou necessite de mais informações, entre
                      em contato com a nossa Central de Atendimento pelo
                      telefone <strong>0800.090.9090</strong> (de segunda a
                      sexta-feira, das 8h30 às 17h30) ou pelo{' '}
                      <strong>Fale Conosco</strong>.
                    </p>
                  </p>
                </div>
              </WideAlert>

              <p className="mb-32">
                <strong>
                  Opção pelo Regime de Tributação do Imposto de Renda
                </strong>
              </p>

              <p className="mb-32">
                A Lei nº 11.053 de 2004, alterada pela Lei nº 14.803 de 2024,
                possibilitou aos assistidos e pensionistas de planos de
                previdência complementar, estruturados na modalidade
                Contribuição Variável (Plano B) ou Contribuição Definida (Plano
                Taesaprev), uma nova oportunidade para a escolha do regime de
                tributação, nos termos da Solução de Consulta nº 68 – COSIT.
              </p>

              <p className="mb-32">
                Nesse contexto, formalizo, por meio do presente Termo, na
                condição de Assistido/Pensionista do plano de previdência
                complementar administrado pela Forluz, a minha opção pelo regime
                tributário abaixo indicado, a incidir sobre os meus benefícios
                previdenciários, conforme as seguintes condições:
              </p>
              <hr className="mt-32 mt-xs-0 mb-32" />
              <Field
                className="mb-3"
                name="tipoRegime"
                component={Radio}
                value="Regressivo"
                initialLabelStrong="Regime Regressivo: "
                label="Os benefícios previdenciários pagos pela Forluz serão tributados com base no artigo 1º da Lei nº 11.053 de 2004, com alíquotas que variam de 35% a 10%, conforme o tempo de acumulação dos recursos no plano. Quanto maior o período de acumulação, menor será a alíquota aplicada. Neste regime, a tributação é exclusivamente na fonte, sem possibilidade de deduções ou ajustes posteriores na Declaração Anual de Imposto de Renda."
              />

              <hr className="mt-32 mt-xs-0 mb-32" />
              <p className=" mt-32">
                <strong>Declarações do Optante:</strong>
              </p>

              <ol className="ts-14 lh-base">
                <li>
                  A opção assinalada é <strong>IRREVOGÁVEL</strong> e{' '}
                  <strong>IRRETRATÁVEL</strong>, aplicando-se aos benefícios
                  futuros, que terão a tributação calculada de acordo com a
                  escolha formalizada neste documento;
                </li>
                <li>
                  O presente requerimento está sujeito à{' '}
                  <strong>análise de elegibilidade</strong> pela Forluz para que
                  produza quaisquer efeitos; e
                </li>
                <li>
                  A nova alíquota de tributação será aplicada aos benefícios na{' '}
                  <strong>competência subsequente</strong> ao do requerimento,
                  caso deferido.
                </li>
              </ol>

              <Field
                className="mb-3 mt-4"
                name="aceite"
                component={Toggler}
                label="Declaro, para todos os fins de direito, que estou ciente de todos os pontos acima."
              />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid || loading}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      {loading ? 'Carregando...' : 'Solicitar'}
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
